import React from "react";
import { FaApple, FaGooglePlay } from "react-icons/fa";

const freelancerProjects = [
  {
    client: "Speedse Logistics",
    description: "Built a full-fledged, scalable truck transportation system using Django REST Framework, inspired by Uber's model. Automated logistics operations including onboarding, verification, truck assignments, and real-time tracking through over 10+ custom APIs. Developed secure authentication using JWT and OTP, and integrated payment management features to handle booking transactions seamlessly. The system supports 10,000+ users and processes 1,000+ OTP requests/day with high performance and reliability.",
    appstore: "https://apps.apple.com/us/app/speed-se/id6747638071", // <-- your App Store link
    playstore: "https://play.google.com/store/apps/details?id=com.speedse.speed_se", // <-- your Play Store link
  },
  {
    client: "Shapeprep",
    description: "Developed a robust portal for an EdTech platform with Django, streamlining student management and operations. Designed a scalable database schema that reduced system downtime by 35%. Wrote MySQL queries and built automated unit/integration tests, improving code quality and cutting bug-related delays by 40%.",
  }
];

const storeBtnStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  background: '#23272b',
  color: '#ff8c00',
  border: 'none',
  borderRadius: '6px',
  padding: '6px 14px',
  fontWeight: 400,
  fontSize: 16,
  marginRight: 10,
  textDecoration: 'none',
  boxShadow: '0 2px 8px 0 rgba(0,0,0,0.10)',
  transition: 'background 0.2s, color 0.2s',
};

const Freelancer = () => (
  <div>
    <section className="resume-section" id="freelancer">
      <div className="resume-section-content">
        <h2 className="mb-5">Freelancer</h2>
        <div className="timeline">
          {freelancerProjects.map((proj, idx) => (
            <div className={`timeline-item ${idx % 2 === 0 ? 'left' : 'right'}`} key={idx} style={{ marginBottom: 48 }}>
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="mb-0 text-primary">{proj.client}</h3>
                <p>{proj.description}</p>
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                  {proj.appstore && (
                    <a
                      href={proj.appstore}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={storeBtnStyle}
                    >
                      <FaApple size={20} /> App Store
                    </a>
                  )}
                  {proj.playstore && (
                    <a
                      href={proj.playstore}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={storeBtnStyle}
                    >
                      <FaGooglePlay size={20} /> Play Store
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    <hr className="m-0" />
  </div>
);

export default Freelancer; 